// export const BASE_URL =
//   // "http://192.168.1.33/ziro-script-laravel/public/crmapi/"; // local
//   // "http://192.168.1.33/ziro-script-laravel/public/crmapi/"; // sujith local
//   // "http://192.168.1.30/newvow-script-laravel/public/crmapi/"; // local
//   "https://ziro.ninositsolution.com/crmapi/"; // live
// // "https://uat.script.zirostays.com/crmapi/"  //UAT,

export const TOKEN = "token";
export const LOGGEDUSER = "loggeduser";
export const USER_DETAILS = "user_details";
export const PROFILE = "profile";
export const LOCATION = "userlocation";
export const LOCATIONNAME = "locationname";
export const GOOGLE_MAP_KEY = "AIzaSyBbDzvqz6Z28lrz3YDGeLIa7maoXXFnVXw"; //DEV
// export const GOOGLE_MAP_KEY = "AIzaSyDyI5lsccJKQP1Qc1h0xVh03aDb3KGzxmk";///LIVE
// export const GOOGLE_MAP_KEY = "AIzaSyAJJyn2YN6kCvs3XxEMC9XIhB1xPGjkBW4";
export const OLA_MAP_KEY = "lcndCmgsSIcmietX3bkCGIFMG1ijjKwLkDA0ZeCK";

export const PASS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*.?&])[A-Za-z\d@$!%.*?&]{8,}$/;
export const isValidEmail = (email) => {
  return EMAIL.test(email);
};
export const NUMBER = /^\+?(0|[6-9]\d*)$/;
export const EMAIL =
  /^[a-z][^<>()[\]\\.,;:\s@\"]*(\.[^<>()[\]\\.,;:\s@\"]+)*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const logger = (data, msg) => console.log(data, msg ? msg : `${data}`);

export const productDetailImg = {
  loop: true,
  autoplay: false,
  center: true,
  dots: true,
  autoplayTimeout: 3000,
  smartSpeed: 450,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
  },
};

export const configJodit = {
  activeButtonsInReadOnly: ["source", "fullsize", "print", "about", "dots"],
  buttons: [
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    "ul", // Unordered list
    "ol", // Ordered list
    "|",
    "fontsize",
    "font",
    "brush", // Text color & background color
    "paragraph", // Format block (Headings)
    "lineHeight", // Line height adjustment
    "align",
    "dots",
  ],
  toolbarSticky: false, // Keeps toolbar flexible
  toolbarAdaptive: true, // Ensures responsiveness
  toolbarButtonSize: "small", // Makes buttons smaller on small screens
  // height: "auto", // Auto height for responsiveness
  // minHeight: 200, // Prevents the editor from collapsing
  spellcheck: true,
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  showPlaceholder: false,
};

// regular expressions to validate password
